<template>
  <div>
    <class-select 
    v-on:changeClass="changeClassTap"
    :classData="classData"
    :classListIndex="classListIndex"
    ></class-select>
    <!-- 功能区 -->
    <div class="toolsb">
      <el-input class="mb-input" placeholder="请输入学生姓名" v-model="query.nickName"></el-input>
      <el-button type="primary" @click="toQuery">搜索</el-button>
      <el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button type="primary" @click="lattab" v-show="tab == false">查看未完成课程的学生</el-button>
      <el-button type="primary" @click="lattab" v-show="tab == true">查看所有学生</el-button>
      <el-button type="primary" @click="Remind" v-if="tab == true">提醒学生</el-button>
    </div>
    <!-- 每个班级的学生表格 -->
    <el-table :data="tableData" v-show="tab == false" tooltip-effect="dark" :stripe="true"
      :header-cell-style="tableHeaderCellStyle">
      <el-table-column prop="sysUser.nickName" label="姓名" align="center"></el-table-column>
      <el-table-column prop="sysUser.userName" label="学号" align="center"></el-table-column>
      <el-table-column prop="sysUser.sex" label="性别" align="center">
        <template slot-scope="scope">{{ scope.row.sysUser.sex | sexFilter }}</template>
      </el-table-column>
      <el-table-column prop="sysUser.phonenumber" label="手机号码" align="center"></el-table-column>
      <el-table-column prop="sysUser.email" label="邮箱" align="center" width="200"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" @click="handlePassword(scope.$index, scope.row)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination class="mb-pagination" v-show="tab == false" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="curPage" :page-size="limit"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <!-- 每个班级未完成课程的学生表格 -->
    <el-table :data="tableLate" v-show="tab == true" tooltip-effect="dark" :stripe="true"
      :header-cell-style="tableHeaderCellStyle">
      <el-table-column prop="sysUser.nickName" label="姓名" align="center"></el-table-column>
      <el-table-column prop="sysUser.userName" label="学号" align="center"></el-table-column>
      <el-table-column prop="sysUser.sex" label="性别" align="center">
        <template slot-scope="scope">{{ scope.row.sysUser.sex | sexFilter }}</template>
      </el-table-column>
      <el-table-column prop="sysUser.phonenumber" label="手机号码" align="center"></el-table-column>
      <el-table-column prop="sysUser.email" label="邮箱" align="center" width="200"></el-table-column>
      <el-table-column prop="course.courseName" label="课程" align="center"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination class="mb-pagination" v-show="tab == true" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="curPage" :page-size="limit"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <!-- 弹框 -->
    <el-dialog :title="dialogTitle == 0 ? '新增' : '编辑'" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form :rules="formInfoRules" ref="formInfo" :model="formInfo" label-width="100px">
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="formInfo.nickName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="学号" prop="userName">
          <el-input v-model="formInfo.userName" placeholder="请输入" :disabled="dialogTitle == 1 ? true : false" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select class="m-input" v-model="formInfo.sex" placeholder="请选择" clearable>
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机" prop="phonenumber">
          <el-input v-model="formInfo.phonenumber" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formInfo.email" placeholder="请输入" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('formInfo')">取 消</el-button>
        <el-button type="primary" @click="submitForm('formInfo')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ClassSelect from "@/components/ClassSelect";
  import pagination from "@/mixins/pagination";
  export default {
    name: "TeacherClass",
    components: { ClassSelect },
    mixins: [pagination],
    data () {
      return {
        addUrl: "/system/user/edit",
        deleteUrl: "",
        editUrl: "/system/user/edit",
        queryUrl: "/teach/user/list",
        tab: false, // 切换表格
        formInfoRules: {
          nickName: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          userName: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          phonenumber: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          email: [
            { required: true, message: "请输入", trigger: "blur" }
          ]
        },
        classData:[],
        classListIndex:0,
      };
    },
    filters: {
      sexFilter (sex) {
        if (parseInt(sex) === 0) {
          return "男";
        } else if (parseInt(sex) === 1) {
          return "女";
        }
      }
    },
    mounted () {
      let that = this;
      this.query.roleId = 100;
      this.getLists()
    },
    methods: {
      handleEdit (index, row) {
        this.formInfo = {
          nickName: row.sysUser.nickName,
          userName: row.sysUser.userName,
          sex: row.sysUser.sex,
          phonenumber: row.sysUser.phonenumber,
          email: row.sysUser.email,
          userId: row.sysUser.userId,
          roleIds: ["101"]
        };
        this.dialogVisible = true;
        this.dialogTitle = 1;
      },
      // tap切换
      changeClassTap (index) {
        this.query.classerId = this.classData[index].classerId;
        this.classListIndex = index;
        this.queryData();
        this.getList()
      },
      handlePassword (index, row) {
        let that = this;
        that.$alert("确定要重置为默认密码jxjy@USer.id吗？", "重置密码", {
          confirmButtonText: "确定",
          callback: action => {
            if (action === "confirm") {
              that.HttpConnection.put("/system/user/resetPwd", {
                userId: row.userId
              }).then(function (response) {
                that.$message({
                  type: "success",
                  message: "重置密码成功"
                });
              });
            }
          }
        });
      },
      //  切换表格
      lattab () {
        this.tab = !this.tab
      },
      // 班级列表
      getLists () {
        let that = this
        that.HttpConnection.get("/teach/classer/list").then((response) => {
          this.classData = response.rows;
          this.changeClassTap(this.classListIndex)
        });
      },
    }
  };
</script>

<style scoped lang="scss">

</style>